import { MatSelect } from '@angular/material/select';

export const MIN_MAT_SELECT_OVERLAY_WIDTH = 150;
let hasPatchedOverlayWidth = false;

export function ensureMatSelectMinWidth(): void {
  if (hasPatchedOverlayWidth) {
    return;
  }

  const matSelectPrototype = MatSelect.prototype as any;
  const originalGetOverlayWidth = matSelectPrototype._getOverlayWidth;

  if (typeof originalGetOverlayWidth !== 'function') {
    return;
  }

  matSelectPrototype._getOverlayWidth = function () {
    const overlayWidth = Number(originalGetOverlayWidth.call(this));

    if (!Number.isNaN(overlayWidth) && overlayWidth > 0) {
      return Math.max(overlayWidth, MIN_MAT_SELECT_OVERLAY_WIDTH);
    }

    return MIN_MAT_SELECT_OVERLAY_WIDTH;
  };

  hasPatchedOverlayWidth = true;
}
